<template>
  <div class="test_com">
    <!-- api/cloud_company_reg_mini_pro_up_idcard -->
    <upfile name="上传图片" :many="1" action="https://weixin.qiyehuo.com/api/ysy_aly_common_upload" :mul="false" :up_path="{'des':des}" bus='abcde'
      acc=".jpeg,.jpg,.png,.pdf" :acce="['img','pdf']" />
  </div>
</template>

<script>
import upfile from '../../common/UpFile.vue'
export default {
  name: 'TestCom',
  components: { upfile },
  data() {
    return {
      des: ''
    }
  },
  mounted () {
    this.des = this.$route.query.des
    console.log(this.des)
    this.$axios.get('https://cha.qiyehuo.com/api/client/wxlogin/wxlogincallback').then(() =>{})
  }
}
</script>

<style scoped>
.test_com {
  /* margin-left: 1.25rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/ysy/testCom.vue